
export const data = [
    {
        id: 1, 
        url: 'https://picsum.photos/400/300?random=1'        
    },
    {
        id: 2,
        url: 'https://picsum.photos/400/300?random=2'
    },
    {
        id: 3,
        url: 'https://picsum.photos/400/300?random=3'
    },
    {
        id: 4,
        url: 'https://picsum.photos/400/300?random=4'
    },
    {
        id: 5,
        url: 'https://picsum.photos/400/300?random=5'
    },
    {
        id: 6,
        url: 'https://picsum.photos/400/300?random=6'
    },
    {
        id: 7,
        url: 'https://picsum.photos/400/300?random=7'
    },
    {
        id: 8,
        url: 'https://picsum.photos/400/300?random=8'
    },
    {
        id: 9,
        url: 'https://picsum.photos/400/300?random=9'
    },
    {
        id: 10,
        url: 'https://picsum.photos/400/300?random=10'
    },
    {
        id: 11,
        url: 'https://picsum.photos/400/300?random=11'
    }
]